/**
 * defa.collections.securitys
 * A Collection of Security
 * @version 1.2.0
 */
import Security from 'scripts/defa/control/security/model-security';

const Securitys = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : Security,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default Securitys